import axios from 'axios';
import { getApiBaseUrl } from '../lib/api-base-url';

export interface OrderAssignment {
  id: number;
  userId: number;
  orderId: number;
  startDate: string;
  endDate: string | null;
  costRate: number | null;
  sellRate: number | null;
  tenantId: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
  order?: {
    id: number;
    code: string;
    description: string;
    client?: {
      id: number;
      name: string;
    };
  };
}

export interface CreateOrderAssignment {
  userId: number;
  orderId: number;
  startDate: string;
  endDate?: string;
  costRate?: number;
  sellRate?: number;
}

export interface UpdateOrderAssignment {
  startDate?: string;
  endDate?: string;
  costRate?: number;
  sellRate?: number;
  isActive?: boolean;
}

export interface SplitOrderAssignment {
  splitDate: string;
  costRate?: number;
  sellRate?: number;
}

const API_URL = getApiBaseUrl();

export const orderAssignmentService = {
  getAll: async (): Promise<OrderAssignment[]> => {
    const response = await axios.get(`${API_URL}/order-assignments`);
    return response.data;
  },

  getById: async (id: number): Promise<OrderAssignment> => {
    const response = await axios.get(`${API_URL}/order-assignments/${id}`);
    return response.data;
  },

  getByUser: async (userId: number): Promise<OrderAssignment[]> => {
    const response = await axios.get(`${API_URL}/order-assignments/user/${userId}`);
    return response.data;
  },

  getByOrder: async (orderId: number): Promise<OrderAssignment[]> => {
    const response = await axios.get(`${API_URL}/order-assignments/order/${orderId}`);
    return response.data;
  },

  create: async (data: CreateOrderAssignment): Promise<OrderAssignment> => {
    const response = await axios.post(`${API_URL}/order-assignments`, data);
    return response.data;
  },

  update: async (id: number, data: UpdateOrderAssignment): Promise<OrderAssignment> => {
    const response = await axios.patch(`${API_URL}/order-assignments/${id}`, data);
    return response.data;
  },

  split: async (
    id: number,
    data: SplitOrderAssignment,
  ): Promise<{ closedAssignment: OrderAssignment; newAssignment: OrderAssignment }> => {
    const response = await axios.post(`${API_URL}/order-assignments/${id}/split`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`${API_URL}/order-assignments/${id}`);
  },
};
